export const getBalanceScript = `
import FungibleToken from 0x9a0766d93b6608b7
import EmeraldBeta from 0x6c0d53c676256e8c

pub fun main(account: Address): UFix64 {

    if let publicVault = getAccount(account).getCapability(EmeraldBeta.TokenPublicBalancePath).borrow<&EmeraldBeta.Vault{FungibleToken.Balance}>() {
        return publicVault.balance
    } else {
        return 0.0
    }
}
`